import reportUpdate from '../../api/index'

const UpdateMP = () => {
    return new Promise((resolve) => {
        resolve(reportUpdate.reportUpdate.updateMP());
    });
};


export default {
    namespaced: true,
    state: {
        mpStatus: null,
    },
    getters: {
    GET_MP_STATUS(state) {
      return state.mpStatus;
    },
  },
    mutations: {
        SET_MP_STATUS(state, payload) {
            state.mpStatus = payload;
        }
    },
    actions: {
        async UPDATE_MP({ commit }) {
            
            await UpdateMP().then(
                ({ 
                    data, status 
                }) => {
                if (status === 200) {
                        commit("SET_MP_STATUS", data);
                    }
                }
            );
        }
    }
}
